import { isUserTab, USER_TAB_RIGHT, type Tab } from "@po/shared";
import { DataTable } from "../components/DataTable";
import { UserRightsTab } from "./UserRightsTab";

/** Unit Info's and User Info's lists (SPEC §8.11, §8.12): each a plain list with a note on what it holds. */
const LISTS: Partial<Record<Tab, { title: string; note: string }>> = {
  "class-societies": { title: "Class societies", note: "Sertica's class societies, with how many units are classed by each." },
  flags: { title: "Flags", note: "Sertica's flags, with how many units fly each." },
  units: { title: "Units", note: "Every unit in Sertica: vessels and offices, with their particulars and the unit groups they are in." },
  "unit-companies": { title: "Unit companies", note: "Which company a unit's records are issued under. Sertica has none set up on TEST." },
  "unit-groups": { title: "Unit groups", note: "How Sertica groups the units, with each group's parent and the units in it." },
  "vessel-types": { title: "Vessel types", note: "Sertica's vessel types, with how many units are of each." },
  roles: { title: "Roles", note: "Sertica's roles, with their user group and the units each is attached to (the units its users see here)." },
  users: { title: "Users", note: "Every Sertica user, with their group, contact details and last login." },
  "user-groups": { title: "User groups", note: "Sertica's user groups, with how many users, roles and granted rights each has." },
};

/** `rights`: the signed-in role's User Info rights; a User Info list needs its own (SPEC §8.12). */
export function UnitUserInfoTab({ tab, rights }: { tab: Tab; rights: string[] }) {
  const l = LISTS[tab];
  if (!l && tab !== "user-rights") return null;
  if (isUserTab(tab) && !rights.includes(USER_TAB_RIGHT[tab as keyof typeof USER_TAB_RIGHT]))
    return <p className="text-[13px] text-muted">Your Sertica role lacks the {USER_TAB_RIGHT[tab as keyof typeof USER_TAB_RIGHT]} right this list needs.</p>;
  if (!l) return <UserRightsTab />;
  return (
    <div className="space-y-4">
      <p className="text-[11.5px] text-muted">{l.note} Only the search applies here.</p>
      <DataTable key={tab} table={tab} title={l.title} lens="plain" />
    </div>
  );
}
